import { SelectUserOrganizationModal } from '@forwardflow/modals'
import { Header } from '../Header'
import SideNav from '../SideNav'

type DashboardContainerType = {
   children?: React.ReactNode
   className?: string
}

export const DashboardContainer = ({
   children,
   className = '',
}: DashboardContainerType) => {
   return (
      <>
         <div className={`flex flex-col min-h-screen`}>
            <Header />
            <div className="flex flex-1">
               <SideNav />
               <section
                  className={`${className} flex-1 pb-8 pt-6 lg:pt-0 px-[30px] lg:pl-0 lg:pr-11  h-[calc(100vh-80px)] overflow-y-auto`}
               >
                  {children}
               </section>
            </div>
            <SelectUserOrganizationModal />
         </div>
      </>
   )
}
